import { isMoment } from "moment"

/** Add a query string item to the array only if it actually has a value */
const addSingleChoiceValueToQueryStringParams = (key, value, params) => {
  const newArray = [...params]
  if (value) {
    newArray.push({ key, value })
  }
  return newArray
}

/** Query string array params need to be like locations=1&locations=2&location=3
 * So this function handles that
 */
const addMultipleChoiceValueToQueryStringParams = (key, selectedValue, params) => {
  const newArray = [...params]
  if (selectedValue) {
    const valuesArray = selectedValue.split(",")
    if (valuesArray.length > 0) {
      valuesArray.forEach((value) => {
        newArray.push({ key, value })
      })
    }
  }
  return newArray
}

const formatDate = (momentDateObj) => {
  if (momentDateObj && isMoment(momentDateObj)) {
    return momentDateObj.format("YYYY-MM-DD")
  }
  return null
}

/** Convert the filter state to an object representing the selected filter values */
export const convertFilterStateToObject = (filterState) => {
  return {
    StartDate: formatDate(filterState.fields.startDate.selectedValue),
    EndDate: formatDate(filterState.fields.endDate.selectedValue),
    Review: filterState.fields.review.selectedValue,
    Locations: filterState.fields.locations.selectedValue,
    Generations: filterState.fields.generations.selectedValue,
    Genders: filterState.fields.genders.selectedValue,
    AppraisalLevels: filterState.fields.appraisalLevels.selectedValue,
    JobTitles: filterState.fields.jobTitles.selectedValue,
    FilterMode: filterState.fields.dataMode.selectedValue,
    Manager: filterState.fields.managers.selectedValue,
    // LocationMode: filterState.fields.?.selectedValue,
    EmployeeInclusion: filterState.fields.viewMode.selectedValue,
  }
}

export const convertFilterStateToPostLocations = (filterState) => {
  const filterLocations = filterState.fields.locations.selectedValue
  const newArray = []

  if (filterLocations) {
    const valuesArray = filterLocations.split(",")
    if (valuesArray.length > 0) {
      valuesArray.forEach((value) => {
        newArray.push(value)
      })
    }
  }

  return newArray
}

/** Conver the filter state to a query string which the API can consume */
export const convertFilterStateToUrlParams = (filterState) => {
  const filters = convertFilterStateToObject(filterState)

  let params = addSingleChoiceValueToQueryStringParams("StartDate", filters.StartDate, [])
  params = addSingleChoiceValueToQueryStringParams("EndDate", filters.EndDate, params)
  params = addSingleChoiceValueToQueryStringParams("Review", filters.Review, params)
  params = addSingleChoiceValueToQueryStringParams("FilterMode", filters.FilterMode, params)
  params = addSingleChoiceValueToQueryStringParams(
    "EmployeeInclusion",
    filters.EmployeeInclusion,
    params
  )
  // params = addMultipleChoiceValueToQueryStringParams("Locations", filters.Locations, params)
  params = addMultipleChoiceValueToQueryStringParams("Generations", filters.Generations, params)
  params = addMultipleChoiceValueToQueryStringParams("Genders", filters.Genders, params)
  params = addMultipleChoiceValueToQueryStringParams(
    "AppraisalLevels",
    filters.AppraisalLevels,
    params
  )
  params = addMultipleChoiceValueToQueryStringParams("JobTitles", filters.JobTitles, params)

  params = addSingleChoiceValueToQueryStringParams("AdminOverrideId", filters.Manager, params)

  return `?${params.map(kvp => `${kvp.key}=${kvp.value}`).join("&")}`
}



// WEBPACK FOOTER //
// ./src/utils/filter-utils.js